export const time = {
    milliseconds_per_second: 1_000,
    seconds_per_minute: 60,
    minutes_per_hour: 60,
    hours_per_day: 24,
    milliseconds_per_day: 1_000 * 60 * 60 * 24
} as const

// emails
export const SUPPORT_EMAIL = "support@guerillarealty.com"
export const NO_REPLY_EMAIL = "no-reply@pipelineprotools.com"

// web-scraping stuff
export const ZILLOW_LINK = "https://www.zillow.com/homedetails/"
export const REDFIN_LINK = "https://www.redfin.com/"
export const REALTORCOM_LINK = "https://www.realtor.com/realestateandhomes-detail/"

export const MIN_SCRAPED_IMAGE_SIZE = 900

// deactivation
export const DO_NOT_DEACTIVATE = -1

export const DEACTIVATED_BY_SYSTEM = "system"
export const DEACTIVATED_BY_ADMIN = "admin"

export const DEACTIVATION_OVERDUE_BILL = "bill is overdue (> 30 days)"
export const DEACTIVATION_ADMIN_MANUAL = "deactivated manually by adminstrator"
export const DEACTIVATION_SUCCESSFUL = 0
export const DEACTIVATION_NOT_SUCCESSFUL = 1

// invites
export const ONTRAPORT_INVITE = "ontraport"

// pagination
export const PAGINATION_FINISHED = -1

// lead stuff
export const NO_WEB_REFERRER = "none"

// keyboard input
export const ENTER_KEYCODE = 13

// regex
export const ONLY_NUMBERS_REGEX = /^\d+$/

// phones
export const CANADA_AND_US_COUNTRY_CODE = "+1"
export const COUNTRY_CODE_CHARACTER_LENGTH = CANADA_AND_US_COUNTRY_CODE.length
export const COMPLETE_PHONE_NUMBER_LENGTH = 10 + COUNTRY_CODE_CHARACTER_LENGTH
export const MAX_PHONE_NUMBER_LENGTH = 10
export const DEFAULT_SMS_NUMBER = process.env.NEXT_PUBLIC_TWILIO_DEFAULT_SMS_NUMBER
export const DEFAULT_VOICE_NUMBER = process.env.NEXT_PUBLIC_TWILIO_DEFAULT_VOICE_NUMBER

// misc
export const DATABASE_DEFAULT_ID_LENGTH = 24
export const INCOMPLETE_AD_LISTING_QUERY_PARAM = "incomplete-listing-ad-id"
export const CAMPAIGN_KEYWORD_REFERER_QUERY_PARAM = "ref"
export const CAMPAIGN_KEYWORD_INCOMPLETE_CAMPAIGN_REF = "newCampaign"
export const TWILLIO_CONNECT_PPT_ENDPOINT = `https://www.twilio.com/authorize/${process.env.NEXT_PUBLIC_TWILIO_CONNECT_PPT_SID}`

// static resources
export const staticResources = {
    favicon: "/favicon.png"
} as const

// all options are taken from qrcode lib docs: 
// https://www.npmjs.com/package/qrcode#qr-code-options
export const qrcode = {
    scale: 12,
    errorCorrectionLevel: "H"
} as const

export const AUTH_TOKEN_KEY = "token-v2"
export const MIN_PASSWORD_LENGTH = 8

export const PPT_PUBLIC_RESOURCES = "ppt-public"
export const PLACEHOLDER_THEME_LOGO = "/logos/onehomesearch.svg"
export const PUBLIC_RESOURCES_BASE_URL = "https://static.gr-apis.com"
export const FIRST_STEPS_PATH = "first-steps"

export const USER_PATHWAY_WINS = {
    FIRST_WIN_HASH: "first-steps:lead",
    SECOND_WIN_HASH_TAIL: "gpPAZMNc",
    THIRD_WIN_HASH_TAIL: "uJuKrbGv",
    EVERGREEN_PLAN_HASH_TAIL: "updateEvergreenPlan",
} as const

export const BEST_IMAGE_COUNT = 5